import React from "react";
import FlexContainerOrg from "../FlexContainerOrg";
import { LogoContainer, MainContainer, Section, Wrapper } from "./FullScreenContainerOrg.styled";
export var FullScreenContainerPaddingUnitLarge = 24;
export var FullScreenContainerPaddingUnitSmall = 8;
function FullScreenContainerOrg(_ref) {
  var offset = _ref.offset,
    children = _ref.children,
    logo = _ref.logo,
    color = _ref.color,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 328 : _ref$width;
  return /*#__PURE__*/React.createElement(Section, {
    $offset: offset,
    $color: color
  }, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(MainContainer, null, children), /*#__PURE__*/React.createElement(LogoContainer, {
    $color: color,
    $width: width
  }, /*#__PURE__*/React.createElement(FlexContainerOrg, {
    hasFullHeight: true,
    alignItems: "flex-end"
  }, logo))));
}
export default FullScreenContainerOrg;